export function getBack(){
    let backend="https://video.ddks.tech";
    return backend;
}
